<template>
  <app-section v-if="showComponent" :title="$t('page.dashboard.campaigns')">
    <template #action>
      <view-all-button :level="1" @click="goToCampaignOverview" />
    </template>
    <app-carousel
      v-slot="{ item }"
      :items="campaigns"
      :items-per-page="1"
      :loop="false"
      :display-item-full-width="1100"
      class="campaign-carousel"
    >
      <campaign-spotlight
        :ticket="item.ticket"
        :workflow="item.workflow"
        :watchers="item.watchers"
        :child-tickets="item.childTickets"
        class="campaign-card-carousel"
      />
    </app-carousel>
  </app-section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type {
  ICampaignSpotlightResponse,
  IViewConfigV2,
  IWorkflowV2
} from '@rready/sdk';
import { useViewSettings } from '@rready/composables';
import CampaignSpotlight from './CampaignSpotlight.vue';
import { useContextStore } from '../../store/contextStore';
import { useProductStore } from '../../store/productStore';

export default defineComponent({
  name: 'CampaignWidget',
  components: {
    CampaignSpotlight
  },
  data() {
    return {
      loading: false,
      campaigns: [] as ICampaignSpotlightResponse[]
    };
  },
  async created() {
    try {
      this.loading = true;
      this.campaigns = await this.$gateway.campaign.loadCampaignSpotlights(
        this.context,
        this.productId,
        this.campaignDashboardSettings?.visibleStatus ?? [],
        this.campaignDashboardSettings?.visibleProducts ?? []
      );
    } catch (e) {
      console.error('Error loading campaigns on dashboard', e);
      this.$toast(this.$t('error.general').toString());
    } finally {
      this.loading = false;
    }
  },
  computed: {
    productId(): string {
      return useProductStore().productId!;
    },
    context(): string {
      return useContextStore().contextId!;
    },
    workflow(): IWorkflowV2 {
      return useProductStore().workflow;
    },
    campaignDashboardSettings(): IViewConfigV2 | undefined {
      const pageSettings = useViewSettings(this.workflow, 'app').page(
        'Dashboard'
      );
      return pageSettings?.campaigns;
    },
    showComponent(): boolean {
      return this.campaigns.length > 0;
    }
  },
  methods: {
    goToCampaignOverview(): void {
      this.$router.push({ name: 'CampaignOverview' });
    }
  }
});
</script>

<style lang="scss" scoped>
.campaign-carousel {
  margin-top: calc(var(--space-4) * -1);
}

.campaign-card-carousel {
  margin: var(--space-3) 0;
  min-width: inherit;
}
</style>
